<template>
 <v-container fluid>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
        >
        <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Add new data item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="CITY"
                  readonly
                  class="font-weight-bold"
                  v-model="CITY"
                >
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  :items="RESTAURANTS"
                  label="RESTAURANT"
                  v-model="RESTAURANT"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  :items="DATELIST"
                  label="DATE"
                  v-model="DATE"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="URL"
                  v-model="URL"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Ruoka_0"
                  v-model="Ruoka_0"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Ruoka_1"
                  v-model="Ruoka_1"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Ruoka_2"
                  v-model="Ruoka_2"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Ruoka_3"
                  v-model="Ruoka_3"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-spacer></v-spacer>
        <p class="red--text"> {{ ERROR_MSG }} </p>
        </v-card-text>
        <v-card-actions>
        
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>

export default {
    name: 'addnewdata',
    props: ['RESTAURANTS', 'CITY', 'DATELIST'],
    data() {
      return {
        dialog: false,
        DATE: '',
        RESTAURANT: '',
        URL: '',
        Ruoka_0: '',
        Ruoka_1: '',
        Ruoka_2: '',
        Ruoka_3: '',
        ERROR_MSG: ''
      }
    },
    methods: {
        saveData() {
            if (!this.CITY) {
                this.ERROR_MSG = "CITY is required!";
            } else if (!this.RESTAURANT) {
                this.ERROR_MSG = "RESTAURANT is required!";
            } else if (!this.DATE) {
                this.ERROR_MSG = "DATE is required!";
            }  else {
                this.ERROR_MSG = '';
                var item = {
                    "CITY_RESTAURANT": this.CITY + "_" + this.RESTAURANT,
                    "CITY": this.CITY,
                    "URL": this.URL,
                    "DATE": this.DATE,
                    "Ruoka_0": this.Ruoka_0,
                    "Ruoka_1": this.Ruoka_1,
                    "Ruoka_2": this.Ruoka_2,
                    "Ruoka_3": this.Ruoka_3
                 };
                console.log("SAVE " , item);
                var response = this.$parent.postApiData(item);
                console.log("RESPONSE: ", response);
                this.dialog = false;
            }
        }
        
    }         
}
</script>



<style scoped>
p{
    font-size: 10px;
}
a {
    color: #0067a7 !important;
    text-decoration: none;
    font-size: 16px;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

th {
    border-bottom-width: 2px;
    vertical-align: top;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}


td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>